import React, { useRef } from 'react';
import { getContentfulField } from 'common/components';

import Section from './Section';

export default function CustomLandingPage({ page, rawPage, venue }) {
  const refs = useRef([]);

  // Get raw (wrapped) sections for form components that need wrapped data
  const rawSections = rawPage?.fields?.sections
    ? getContentfulField(rawPage.fields.sections)
    : [];

  return (
    <div style={{ overflowX: 'clip', overflowY: 'visible' }}>
      {page.fields.sections.map((section, index) => {
        return (
          <Section
            section={section}
            rawSection={rawSections[index]}
            key={index}
            refs={refs}
            index={index}
            venue={venue}
          />
        );
      })}
    </div>
  );
}
